module.exports = __webpack_public_path__ + "static/img/V-M50ar@2x.47898008.png";